import classNames from 'classnames';
import { useContext } from 'react';
import MultiTradeCard from '@/common/TradeCard/MultiTradeCard';
import SptErrorState from '@/vdp/PriceDetails/SptPriceDetails/SptPriceDetailsContent/SptErrorState';
import SoftPullStatus from '~/constants/softPullStatus';
import TradeContext from '~/context/common/TradeContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useSoftPullStatus from '~/hooks/vdp/selectors/useSoftPullStatus';
import useIsHighNetTrade from '~/hooks/vdp/useIsHighNetTrade';
import { PricingError } from '~/services/srp/contracts/PricingResponse';
import { Container } from './SptPriceDetailsContent.styles';
import WithoutSoftPull from './WithoutSoftpull/WithoutSoftpull';
import WithSoftPull from './WithSoftpull/WithSoftpull';
import MarketValue from '../MarketValue';

const SptPriceDetailsContent = () => {
  const { softPullStatus } = useSoftPullStatus();
  const { toggleAppliedTrade, setTradeInApplied } = useContext(TradeContext);
  const { vdpPricingError } = useContext(UserVehicleContext);
  const isHighNetTrade = useIsHighNetTrade();

  return (
    <Container
      className={classNames({
        'mt-16': softPullStatus === SoftPullStatus.Active
      })}
    >
      {vdpPricingError !== PricingError.None ? (
        <SptErrorState />
      ) : softPullStatus === SoftPullStatus.Active ? (
        <WithSoftPull />
      ) : (
        <WithoutSoftPull />
      )}
      <MultiTradeCard
        toggleTrade={toggleAppliedTrade}
        isHighNetTrade={isHighNetTrade}
        onMultiTradeSelect={() => {
          setTradeInApplied(true);
        }}
      />
      <MarketValue />
    </Container>
  );
};

export default SptPriceDetailsContent;
